<template>
    <!-- main container -->
    <div id="ml_app" style="width: 100%; margin-top: 20px;">
        <b-tabs content-class="mt-2">
            <b-tab title="Analyse">
                <div style="display: grid;">
                    <div style="position: relative; float: left; top: 0px;">
                        <h3>Files ready to be analysed</h3>
                        <b-table striped hover :items="files" responsive="sm" filterByFormatted="true"></b-table>

                        <div class="action-buttons">
                            <div class="action-button" style="float: left;">
                                <b-input-group size="lg">
                                    <b-form-file v-model="fileToUpload" multiple accept="image/jpeg,image/png,.pdf" @change=set_file
                                        :state="Boolean(fileToUpload)" no-drop
                                        placeholder="Choose file(s)..."
                                        drop-placeholder="Drop file here..."></b-form-file>
                                    <b-input-group-append>
                                        <b-button :active="Boolean(fileToUpload)" :disabled="!Boolean(fileToUpload)" @click="upload_files" variant="outline-success"><i class="fa-solid fa-cloud-arrow-up" style="padding-right: 10px;"></i>Upload file(s)</b-button>
                                    </b-input-group-append>
                                    <b-button type="button" class="btn btn-success" id="btnOCR" variant="success" @click="ocr()" :disabled="(analysingResults || files.length === 0)" :active="(!analysingResults && files.length > 0)">
                                        <div v-if="!analysingResults"><i class="fa-solid fa-barcode" style="padding-right: 10px;"></i>{{ (files.length === 0 ? "No file(s) to analyse" : "Analyse file(s)") }}</div>
                                        <div v-if="analysingResults"><i class="fa-solid fa-circle-notch fa-spin" style="padding-right: 10px;"></i>Analysing file(s)</div>
                                    </b-button>
                                </b-input-group>
                            </div>
                        </div>
                    </div>
                    <div v-if="analysedData.length > 0" style="position: relative; bottom: 0px; padding-top: 15px;">
                        <h3>Analysed files results</h3>
                        <div v-for="item in analysedData" v-bind:key="item.ID">
                            <span style="font-weight: bold; font-size: large;">{{ item.ID }}</span>
                            <b-container>
                                <b-row><b-col>Average Confidence: <b-badge variant="primary">{{ item.AverageConfidence }}
                                            %</b-badge></b-col></b-row>
                                <b-row
                                    cols="6"><b-col><strong>Field</strong></b-col><b-col><strong>Value</strong></b-col><b-col><strong>Confidence</strong></b-col></b-row>
                                <b-row cols="6">
                                    <b-col>Donor</b-col><b-col>{{ item.Donor.Text }}</b-col><b-col><b-badge pill
                                            variant="primary">{{ item.Donor.Confidence }} %</b-badge></b-col>
                                </b-row>
                                <b-row cols="6">
                                    <b-col>Donor ID</b-col><b-col>{{ item.DonorID.Text }} </b-col><b-col><b-badge
                                            variant="primary">{{ item.DonorID.Confidence }} %</b-badge></b-col>
                                </b-row>
                                <b-row cols="6">
                                    <b-col>Species</b-col><b-col>{{ item.Species.Text }} </b-col><b-col><b-badge
                                            variant="primary">{{ item.Species.Confidence }} %</b-badge></b-col>
                                </b-row>
                                <b-row cols="6">
                                    <b-col>Breed</b-col><b-col>{{ item.Breed.Text }} </b-col><b-col><b-badge
                                            variant="primary">{{ item.Breed.Confidence }} %</b-badge></b-col>
                                </b-row>
                                <b-row cols="6">
                                    <b-col>Total No. Sperm Analysed</b-col><b-col>{{ item.TotalSpermAnalysed.Text }}
                                    </b-col><b-col><b-badge variant="primary">{{ item.TotalSpermAnalysed.Confidence }}
                                            %</b-badge></b-col>
                                </b-row>
                                <b-row cols="6">
                                    <b-col>Total Motility</b-col><b-col>{{ item.TotalMotility.Text }}
                                    </b-col><b-col><b-badge variant="primary">{{ item.TotalMotility.Confidence }}
                                            %</b-badge></b-col>
                                </b-row>
                                <b-row cols="6">
                                    <b-col>Concentration</b-col><b-col>{{ item.Concentration.Text }} </b-col><b-col><b-badge
                                            variant="primary">{{ item.Concentration.Confidence }} %</b-badge></b-col>
                                </b-row>
                                <br />
                            </b-container>
                        </div>
                        <!-- <b-table :items="analysedData" xl striped hover sortable sticky-header responsive="lg" >
                            <template v-slot:cell(value)="data">
                                <b>{{ data.key }}</b>: {{ data.value.Text }}
                                <span v-if="data.value.Confidence"> (Confidence: {{ data.value.Confidence }})</span>
                            </template>
                        </b-table>

                        <b-table :items="analysedData" xl striped hover sortable sticky-header responsive="lg" :fields="fields" detailed@row-details="rowDetails">
                            
                        </b-table> -->
                    </div>
                </div>
            </b-tab>

            <b-tab title="Review">
                <template #title>
                    Review <b-badge v-if="new_items" variant="primary">{{ new_items }}</b-badge>
                </template>
                <div style="display: grid;">
                    <div style="position: relative; float: left; top: 0px;">
                        <h3>Files previously analysed</h3>

                        <b-table id="ocrResultsTable" xl striped hover sortable sticky-header 
                            :items="ocrResultsFromDB"
                            responsive="lg"
                            :per-page="perPage"
                            :current-page="currentPage"></b-table>

                        <div style="display: block;">
                            <div style="position: relative; float: left; margin-right: 10px;">
                                <b-button @click="export_results" variant="success" size="sm"><i class="fa-solid fa-download" style="margin-right: 10px;"></i>Download</b-button>
                            </div>
                            <div style="position: relative; float: left; margin-right: 10px;">
                                <b-button @click="getOCRResultsFromDB" variant="outline-secondary" size="sm"><i class="fa-solid fa-arrows-rotate" style="margin-right: 10px;"></i>Refresh</b-button>
                            </div>
                            <div style="position: relative; float: right;">
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                    aria-controls="ocrResultsTable"
                                    first-text="First"
                                    prev-text="Prev"
                                    next-text="Next"
                                    last-text="Last"
                                ></b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </b-tab>

            <!-- <b-tab title="OCR To Packaging"> -->
            <!--<p class="decode-result">Last result: <b>{{ qr_result }}</b></p>

<div class="qr_stream">
<qrcode-stream @decode="onDecodeQR"></qrcode-stream>
</div>-->
            <!-- <h3>Attach OCR Results to Packaging</h3>
<div>
<input type="file" accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" @change="set_excel_file">

<b-button type="button" class="btn btn-success" id="btnExcelImport" variant="success" @click="import_excel()" :disabled="!excelFile && !importing_file">
Import data <i class="fa-solid fa-file-excel" style="padding-left: 5px;"></i>
</b-button>
</div>

<b-table striped hover :items="excelResults"></b-table>
</b-tab> -->
        </b-tabs>
    </div>
</template>

<script>
// Import the AWS SDK for JavaScript
import AWS from 'aws-sdk';
import readXlsxFile from 'read-excel-file';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import moment from 'moment'

export default {
    name: 'OCR',
    components: {},
    data: function () {
        return {
            previewFileURL: null,
            fileToUpload: null,
            filesToUpload: null,
            files: [],
            textractResults: [],
            analysedData: [],
            fields: ['key', 'value'],
            analysingResults: false,

            qr_result: null,

            ocrResultsFromDB: [],

            excelFile: null,
            excelResults: [],
            importing_file: false,

            rows: 0,
            perPage: 10,
            currentPage: 1,

            new_items: null,
        };
    },
    props: [],
    mounted: function () {
        this.getFilesFromS3();
        this.getOCRResultsFromDB();
    },
    methods: {
        set_file(e) {
            const file = e.target.files[0];
            this.previewFileURL = URL.createObjectURL(file);
            this.fileToUpload = file;
            this.filesToUpload = e.target.files;
        },
        set_excel_file(e) {
            console.log("Excel changed")
            this.excelFile = e.target.files[0];
        },
        import_excel() {
            this.importing_file = true;
            readXlsxFile(this.excelFile).then(async (rows) => {
                for (var i = 6; i < rows.length; i++) {
                    this.excelResults.push(rows[i])

                    var rowNum = i + 1

                    var date = new Date(rows[i][1]);
                    var site = rows[i][2];
                    var donorID = rows[i][3];
                    var packageID = rows[i][4];
                    var spermMotility = rows[i][5];
                    var spermConcentration = rows[i][6];
                    var cryoprotectant = rows[i][7];
                    var grade = rows[i][8];
                    var lnDewarNo = rows[i][9];
                    var lnCanisetrNo = rows[i][10];
                    var notes = rows[i][11];

                    let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                    let headers = {
                        'Content-Type': 'application/json;charset=utf-8',
                        'authorization': localStorage.idtoken
                    };

                    var data = {
                        "endpoint": "/api/AquacultureOCR/SaveExcelResults?" +
                            "RowNumber=" + rowNum + "&" +
                            "Date=" + date.toISOString() + "&" +
                            "Site=" + site + "&" +
                            "FishID=" + donorID + "&" +
                            "PackagingID=" + packageID + "&" +
                            "SpermMotility=" + spermMotility.replace("%", "") + "&" +
                            "SpermConcentration=" + spermConcentration + "&" +
                            "Cryoprotectant=" + cryoprotectant + "&" +
                            "Grade=" + grade + "&" +
                            "LNDewarNumber=" + lnDewarNo + "&" +
                            "LNCanisterNumber=" + lnCanisetrNo + "&" +
                            "Notes=" + notes
                    };

                    data = JSON.stringify(data);

                    try {
                        /*const response = */await this.$http.post(
                            url,
                            data,
                            { headers: headers }
                        );

                        //console.log(response.data);

                    } catch (error) {
                        console.log("Error...")
                        console.log(error);
                    }

                }
            });

            this.importing_file = false;
        },
        addPackageToDonor() {
            console.log("packet scanned")
        },
        onDecodeQR(decodedString) {
            console.log(decodedString)
            this.qr_result = decodedString;
        },
        async upload_files() {
            const me = this;

            var albumBucketName = 'textract-casa-analysedfiles';

            for (var i = 0; i < this.filesToUpload.length; i++){
                const file = this.filesToUpload[i]
                var fileKey = file.name;
                
                // Use S3 ManagedUpload class as it supports multipart uploads
                var upload = new AWS.S3.ManagedUpload({
                    params: {
                        Bucket: albumBucketName,
                        Key: fileKey,
                        Body: file
                    }
                });

                var promise = upload.promise();

                promise.then(
                    function (data) {
                        console.log(data)
                        me.getFilesFromS3();
                    },
                    function (err) {
                        console.log(err.message)
                    }
                );
            }
        },
        async ocr() {
            this.analysingResults = true;
            this.new_items = null;

            var me = this;

            var lambda_handler = new AWS.Lambda(AWS.config);

            this.files.forEach(file => {

                var request = {
                    "var_1": "s3://textract-casa-analysedfiles/" + file.Name,
                    "var_2": ""
                };

                var pullParams = {
                    FunctionName: 'bz-textract-text-extraction',
                    InvocationType: 'RequestResponse',
                    LogType: 'None',
                    Payload: JSON.stringify(request)
                };
                var pullResults;

                // Create a promise wrapper for the lambda_handler.invoke() function
                var invokePromise = new Promise(function (resolve, reject) {
                    lambda_handler.invoke(pullParams, function (error, data) {
                        if (error) reject(error);
                        else {
                            pullResults = JSON.parse(data.Payload);
                            resolve(pullResults)
                        }
                    });
                });

                // Use the promise to ensure that pullResults is set before accessing it
                invokePromise.then(async function (results) {
                    var donorRow;
                    var idRow;
                    var speciesRow;
                    var breedRow;
                    var dateRow;
                    var totalNumSpermAnalysedRow;
                    var concentrationRow;
                    var totalMotilityRow;
                    var operatorIDRow;

                    var analyseFilesLoop = 0;

                    results = JSON.parse(results.body)

                    results.forEach(element => {
                        if (element.BlockType == 'LINE') // Filter down to 'LINE' values (we don't want single words)
                        {
                            if (element.Text == "Date of analysis:") dateRow = analyseFilesLoop + 1
                            if (element.Text == "Donor:") donorRow = analyseFilesLoop + 1
                            if (element.Text == "ID:") idRow = analyseFilesLoop + 1
                            if (element.Text == "Species:") speciesRow = analyseFilesLoop + 1
                            if (element.Text == "Breed:") breedRow = analyseFilesLoop + 1
                            if (element.Text == "Total number of sperm analyzed:") totalNumSpermAnalysedRow = analyseFilesLoop + 1
                            if (element.Text == "Concentration:") concentrationRow = analyseFilesLoop + 2
                            if (element.Text == "Total motility:") totalMotilityRow = analyseFilesLoop + 2
                            if (element.Text && element.Text.startsWith("Email: ")) operatorIDRow = analyseFilesLoop;
                        }
                        analyseFilesLoop++
                    });

                    const averageConfidence = (
                        results[dateRow].Confidence +
                        results[donorRow].Confidence +
                        results[idRow].Confidence +
                        results[speciesRow].Confidence +
                        results[breedRow].Confidence +
                        results[totalNumSpermAnalysedRow].Confidence +
                        (concentrationRow === undefined ? 0 : results[concentrationRow].Confidence) +
                        results[totalMotilityRow].Confidence +
                        results[operatorIDRow].Confidence
                    ) / (concentrationRow === undefined ? 8 : 9)

                    const reading = {
                        'ID': file.Name,
                        'FileName': file.Name,
                        'AverageConfidence': averageConfidence.toFixed(2),

                        'Date': { 'Text': results[dateRow].Text, 'Confidence': results[dateRow].Confidence.toFixed(2) },
                        'Donor': { 'Text': results[donorRow].Text, 'Confidence': results[donorRow].Confidence.toFixed(2) },
                        'DonorID': { 'Text': results[idRow].Text, 'Confidence': results[idRow].Confidence.toFixed(2) },
                        'Species': { 'Text': results[speciesRow].Text, 'Confidence': results[speciesRow].Confidence.toFixed(2) },
                        'Breed': { 'Text': results[breedRow].Text, 'Confidence': results[breedRow].Confidence.toFixed(2) },
                        'TotalSpermAnalysed': { 'Text': results[totalNumSpermAnalysedRow].Text, 'Confidence': results[totalNumSpermAnalysedRow].Confidence.toFixed(2) },
                        'Concentration': { 'Text': (concentrationRow === undefined ? 'N/A' : results[concentrationRow].Text), 'Confidence': (concentrationRow === undefined ? 'N/A' : results[concentrationRow].Confidence.toFixed(2)) },
                        'TotalMotility': { 'Text': results[totalMotilityRow].Text, 'Confidence': results[totalMotilityRow].Confidence.toFixed(2) },
                        'Operator': { 'Text': results[operatorIDRow].Text.replace("Email: ", ""), 'Confidence': results[operatorIDRow].Confidence.toFixed(2) },
                    }
                    me.analysedData.push(reading);

                    const item = {
                        "DocumentName": reading.FileName,
                        "Breed": reading.Breed.Text,
                        "Operator": reading.Operator.Text,
                        "ID": reading.ID,
                        "AverageConfidence": reading.AverageConfidence,
                        "Concentration": reading.Concentration.Text,
                        "Tot_No_Sperm_Analysed": reading.TotalSpermAnalysed.Text,
                        "Total_Motility": reading.TotalMotility.Text,
                        "Donor": reading.Donor.Text,
                        "DateAnalysed": reading.Date.Text,
                        "DonorID": reading.DonorID.Text,
                        "Species": reading.Species.Text
                    }
                    me.ocrResultsFromDB.push(item)
                    me.new_items = me.new_items + 1;

                    /* Move the file and save its processed data to the DB */
                    me.move_processed_file(file);
                    me.saveResultsToDB(reading)
                    me.analysingResults = false;
                    
                }).catch(function (error) {
                    console.log(error);
                    me.analysingResults = false;
                });
            });
        },
        async saveResultsToDB(reading) {            
            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/AquacultureOCR?" +
                    "DocumentName=" + reading.FileName + "&" +
                    "Breed=" + reading.Breed.Text + "&" +
                    "Operator=" + reading.Operator.Text + "&" +
                    "ID=" + reading.ID + "&" +
                    "AverageConfidence=" + reading.AverageConfidence + "&" +
                    "Concentration=" + (reading.Concentration.Text === undefined ? "" : reading.Concentration.Text) + "&" +
                    "Tot_No_Sperm_Analysed=" + reading.TotalSpermAnalysed.Text + "&" +
                    "Total_Motility=" + reading.TotalMotility.Text + "&" +
                    "Donor=" + reading.Donor.Text + "&" +
                    "DonorID=" + reading.DonorID.Text + "&" +
                    "Species=" + reading.Species.Text
            };

            data = JSON.stringify(data);

            try {
                /*const response = */await this.$http.post(
                    url,
                    data,
                    { headers: headers }
                );

                // console.log(response.data);

            } catch (error) {
                console.log("Error...")
                console.log(error);
            }
            
            
        },
        async move_processed_file(file) {
            const sourceBucket = 'textract-casa-analysedfiles';
            const destinationBucket = 'textract-ocr-processed-files';
            const fileName = file.Name;

            const s3 = new AWS.S3();

            // Copy the object to the destination bucket
            const copyParams = {
                Bucket: destinationBucket,
                CopySource: `/${sourceBucket}/${fileName}`,
                Key: fileName,
            };

            try {
                await s3.copyObject(copyParams).promise();
                // If the copy is successful, delete the object from the source bucket
                const deleteParams = {
                    Bucket: sourceBucket,
                    Key: fileName,
                };

                await s3.deleteObject(deleteParams).promise();

                console.log(`File ${fileName} moved from ${sourceBucket} to ${destinationBucket}`);
            } catch (error) {
                console.error('Error moving file:', error);
            }

            this.getFilesFromS3();
        },
        async getFilesFromS3() {
            var me = this;
            this.fileToUpload = null;
            this.files = [];

            var lambda_handler = new AWS.Lambda(AWS.config);

            var pullParams = {
                FunctionName: "Textract-AnalyseAllS3ObjectsInBucket",
                InvocationType: 'RequestResponse',
                LogType: 'None',
                Payload: JSON.stringify({})
            };
            var pullResults;

            // Create a promise wrapper for the lambda_handler.invoke() function
            var invokePromise = new Promise(function (resolve, reject) {
                lambda_handler.invoke(pullParams, function (error, data) {
                    if (error) reject(error);
                    else {
                        pullResults = JSON.parse(data.Payload);
                        resolve(pullResults)
                    }
                });
            });

            // Use the promise to ensure that pullResults is set before accessing it
            invokePromise.then(function (results) {// Remove unnecessary fields
                for (var i = 0; i < results.body.KeyCount; i++) {
                    if (!(results.body.Contents[i].Key.endsWith('/')) && (results.body.Contents[i].Size > 1)) // Effectively excludes the 'folder'
                    {
                        me.files.push({
                            'Name': results.body.Contents[i].Key,
                            'Size (MB)': (results.body.Contents[i].Size / 1000000).toFixed(1) + ' MB',
                            'Uploaded': moment(new Date(results.body.Contents[i].LastModified)).fromNow()
                        })
                    }
                }
            }).catch(function (error) {
                console.log(error);
            });
        },
        async getOCRResultsFromDB() {
            this.ocrResultsFromDB = [];
            this.new_items = null;

            let url = process.env.VUE_APP_MULE_PROXY_API_URI;

            let headers = {
                'Content-Type': 'application/json;charset=utf-8',
                'authorization': localStorage.idtoken
            };

            var data = {
                "endpoint": "/api/AquacultureOCR/Results"
            };

            data = JSON.stringify(data);

            try {
                const response = await this.$http.post(
                    url,
                    data,
                    { headers: headers }
                );

                // console.log("OCR Results from DB:")
                // console.log(response)
                for (var i = 0; i < response.data.length; i++) {
                    var element = response.data[i]

                    //console.log(element)
                    this.ocrResultsFromDB.push(element)
                }
            } catch (error) {
                console.log(error);
            }

            this.rows = this.ocrResultsFromDB.length;
        },
        export_results() {
            console.log(this.ocrResultsFromDB)
            saveExcel({
                data: this.ocrResultsFromDB,
                fileName: "deviceBatchData-basic",
                columns: [
                    { field: 'DocumentName', title: 'Document Name' },
                    { field: 'AverageConfidence', title: 'Average Confidence' },
                    { field: 'Donor', title: 'Donor' },
                    { field: 'DonorID', title: 'Donor ID' },
                    { field: 'Breed', title: 'Breed' },
                    { field: 'Concentration', title: 'Concentration' },
                    { field: 'Tot_No_Sperm_Analysed', title: 'Total Number of Sperm Analysed' },
                    { field: 'Total_Motility', title: 'Total Motility' },
                    { field: 'DateAnalysed', title: 'Date Analysed' },
                    { field: 'Operator', title: 'Operator' },
                ],
            });
            
        }
    },

}
</script>

<style>
.flex-container {
    display: flex;
}

.action-buttons {
    display: block;
}

.action-button {
    position: relative;
}

#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    max-width: 100%;
    max-height: 500px;
}

.qr_stream {
    max-width: 120px;
    max-height: 120px;
}

</style>